
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useDeactivateCampaign = (userId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string): Promise<void> => {
      console.log('🔄 Deactivating campaign:', id);
      
      // Reverter regras da campanha via função do banco
      const { error: rulesError } = await supabase.rpc('revert_campaign_rules', {
        campaign_id_param: id
      });

      if (rulesError) throw rulesError;

      // Atualizar status para completado
      const { error: updateError } = await supabase
        .from('campaigns')
        .update({ status: 'completed' })
        .eq('id', id);

      if (updateError) throw updateError;

      console.log('✅ Campaign status updated to completed');

      // CHAMAR WEBHOOK DIRETAMENTE - SEM AGUARDAR TRIGGER DO BANCO
      try {
        console.log('🚀 CALLING WEBHOOK DIRECTLY for campaign completion...');
        const { data, error: webhookError } = await supabase.functions.invoke('campaign-automation-webhook', {
          body: { 
            auto_process: true, 
            campaign_id: id,
            event_type: 'campaign.completed',
            direct_call: true  // Flag para indicar chamada direta
          }
        });

        if (webhookError) {
          console.error('❌ Error calling completion webhook directly:', webhookError);
          toast.error("Campanha finalizada, mas houve erro no envio do webhook");
        } else {
          console.log('✅ Completion webhook called directly:', data);
          if (data?.processed > 0) {
            toast.success(`Campanha finalizada e webhook enviado com sucesso!`);
          } else {
            toast.success("Campanha finalizada com sucesso");
          }
        }
      } catch (error) {
        console.error('❌ Failed to call completion webhook directly:', error);
        toast.success("Campanha finalizada com sucesso");
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['campaigns', userId] });
    },
    onError: (error) => {
      console.error('❌ Error deactivating campaign:', error);
      toast.error("Erro ao finalizar campanha");
    },
  });
};
